(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-media-gallery"] && !Shopify.designMode) return;
  try {
    function initProductGallerySwiper() {
    const el = document.querySelector(".product-gallery-swiper-wrapper");
    if (!el || el.dataset.initialized) return;

    // En onglet d'arrière-plan, Swiper mesure mal les dimensions et se positionne
    // parfois sur la dernière slide. On attend que l'onglet devienne visible.
    if (document.hidden) {
      document.addEventListener("visibilitychange", function onVisible() {
        if (!document.hidden) {
          document.removeEventListener("visibilitychange", onVisible);
          initProductGallerySwiper();
        }
      });
      return;
    }

    el.dataset.initialized = true;

    const thumbsEl = document.querySelector(".product-gallery-thumbs");
    const slidesPerView = Number(thumbsEl.dataset.slidesPerView) || 8;

    const slideHeight = 40;
    const slideGap = 10;

    thumbsEl.style.height =
    slideHeight * slidesPerView + slideGap * (slidesPerView - 1) + "px";

    const thumbs = new Swiper(thumbsEl, {
      direction: "vertical",
      slidesPerView: slidesPerView,
      spaceBetween: slideGap,
      watchSlidesProgress: true,
      observer: true,
      observeParents: true,
      freeMode: {
        enabled: true,
        sticky: false,
      },
      allowTouchMove: true,
      mousewheel: {
        enabled: true,
        forceToAxis: true,
        sensitivity: 1
      }
    });


    const swiper = new Swiper(".product-gallery-swiper", {
      direction: "horizontal",
      slidesPerView: "auto",
      spaceBetween: 0,
      observer: true,
      observeParents: true,
      thumbs: { swiper: thumbs },
      mousewheel: {
        enabled: true,
        forceToAxis: true,
        sensitivity: 1
      },
      freeMode: {
        enabled: true,
        sticky: false,
        momentum: true
      },
      navigation: {
        nextEl: '.next',
        prevEl: '.prev'
      },
      autoHeight: true,
      breakpoints: {
        768: {
            direction: 'vertical'
        }
      }
    });

    if (window.innerWidth < 768) {
      const galleryEl = document.querySelector('.product-gallery-swiper');

      // À 2 doigts, Swiper lâche la main pour laisser le pinch-zoom natif
      // de la page agir (autorisé via touch-action: pinch-zoom en CSS)
      galleryEl.addEventListener('touchstart', (e) => {
        if (e.touches.length > 1) swiper.allowTouchMove = false;
      }, { capture: true, passive: true });

      ['touchend', 'touchcancel'].forEach((evt) => {
        galleryEl.addEventListener(evt, (e) => {
          if (e.touches.length === 0) swiper.allowTouchMove = true;
        }, { passive: true });
      });
    }

    // Swiper est prêt : on révèle la galerie
    el.classList.add("is-ready");
  }

  // Filet de sécurité : si le JS/Swiper échoue, on révèle quand même la galerie
  // une fois la page complètement chargée pour ne jamais la laisser masquée.
  function revealProductGalleries() {
    document
      .querySelectorAll(".product-gallery-swiper-wrapper")
      .forEach((el) => el.classList.add("is-ready"));
  }

  document.addEventListener("shopify:section:load", initProductGallerySwiper);
  document.addEventListener("DOMContentLoaded", initProductGallerySwiper);
  window.addEventListener("load", revealProductGalleries);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["share-button"] && !Shopify.designMode) return;
  try {
    let share_btns = document.querySelectorAll('.share-link-button');

share_btns.forEach((btn) => {
  btn.addEventListener('click', handleShare);
});

function handleShare (e) {
  e.preventDefault();

  if (typeof window === 'undefined') return;
  const url = window.location.href;

  if (navigator.share) {
    navigator.share({ url });
  } else if (navigator?.clipboard?.writeText) {
    navigator.clipboard.writeText(url);
  }
};
  } catch(e) { console.error(e); }
})();

})();
